import { memo } from 'react';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import ToggleNotice from '@wconcept/wconcept-ui-renewal/components/molecules/_notice/ToggleNotice';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  imgSrc?: string;
  rs?: string;
  priority?: boolean;
  noticeList?: string[];
  colorType?: ColorType;
  /** 버튼 문구. 응모=참여하기 / 알림=신청하기 등 호출부에서 결정 (기본: 참여하기) */
  buttonText?: string;
  onClick?: () => void;
  onNoticeToggle?: (active: boolean) => void;
}

const RaffleEventSection = ({
  imgSrc,
  rs,
  priority,
  noticeList,
  colorType = 'white',
  buttonText = '참여하기',
  onClick,
  onNoticeToggle,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'raffle-event',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  return (
    <S.RaffleEventSection
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
      $pointColor={customColors?.pointColor}
      $emphasisTextColor={customColors?.emphasisTextColor}
    >
      <div className="visual-wrap img-wrap">
        <Img
          src={getResizeImageUrl(imgSrc, rs)}
          priority={priority}
          alt="raffle event main"
        />
      </div>

      <Button className="raffle-event-btn" onClick={onClick}>
        {buttonText}
      </Button>

      {noticeList && Array.isArray(noticeList) && (
        <ToggleNotice
          onNoticeToggle={onNoticeToggle}
          noticeList={noticeList}
          titleColor={customColors?.textColor}
          noticeColor={customColors?.textColor}
          hideBullet
        />
      )}
    </S.RaffleEventSection>
  );
};

export default memo(RaffleEventSection);
